import React, { useState, useEffect } from "react";
import { string } from "prop-types";
import uniqueid from "lodash.uniqueid";
import FocusLock from "react-focus-lock";

const propTypes = { label: string, text: string };
const ttid = uniqueid("tooltip-");

const Tooltip = (props) => {
  const { label, text } = props;
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const handleMouse = (val) => {
    if (window.innerWidth < 1024) return false;
    setTooltipOpen(val);
  };
  const disableLock = () => {
    if (window.width > 1023) return true;
    return !tooltipOpen;
  };
  useEffect(() => {
    if (window.innerWidth < 1024) {
      if (tooltipOpen) {
        document.querySelector("body").classList.add("prevent-scroll");
      } else {
        document.querySelector("body").classList.remove("prevent-scroll");
      }
    }
  }, [tooltipOpen]);

  return (
    <div className="tooltip">
      <button
        aria-label={label}
        aria-describedby={`${ttid}-inner`}
        aria-controls={ttid}
        className="tooltip__toggle"
        onMouseOver={(e) => handleMouse(true)}
        onMouseOut={(e) => handleMouse(false)}
        onFocus={() => handleMouse(true)}
        onBlur={() => handleMouse(false)}
        onClick={(e) => {
          e.preventDefault();
          setTooltipOpen(!tooltipOpen);
        }}
      ></button>
      <div style={{ visibility: tooltipOpen ? "visible" : "hidden" }}>
        <FocusLock
          disabled={disableLock()}
          returnFocus={window.innerWidth < 1024}
          className="tooltip__msg"
          aria-modal={window.innerWidth < 1024}
          id={ttid}
          role={window.innerWidth < 1024 ? "dialog" : "tooltip"}
          aria-hidden={!tooltipOpen}
        >
          <button
            className="tooltip__close"
            aria-label="close"
            onClick={() => setTooltipOpen(false)}
          ></button>
          <div
            id={`${ttid}-inner`}
            className="tooltip__text"
            dangerouslySetInnerHTML={{ __html: text }}
          />
        </FocusLock>
      </div>
    </div>
  );
};

Tooltip.propTypes = propTypes;
export default Tooltip;
